<template>
  <div>
    <b-form-input
      id="input_unit"
      size="sm"
      :disabled="this.$props.isDisabled"
      v-model="unitQuery"
      @focus="onFocusInUnits"
      @blur="onFocusOutUnits"/>

    <b-list-group class="unit-autocomplete-input" v-if="unitsFocus">
      <b-list-group-item v-for="(item, index) in filteredUnits" :key="index" @mousedown="onClickUnit(item.code)" button>
        {{ getUnitListText(item) }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import unitsStore from "../../utilites/unitStore";

export default {
  name: "UnitSelect",
  mixins: [unitsStore],
  props: {
    isDisabled: Boolean,
    isShort: {
      default: false,
      type: Boolean
    },
    initialUnit: String,
  },
  data() {
    return {
      units_catalog: [],
      unitsFocus: false,
      currentUnit: {
        code: "539",
        fullName: "Человеко-час",
        shortName: "чел.ч",
        shortNameCode: "ЧЕЛ.Ч"
      },
      unitQuery: "Человеко-час"
    }
  },
  async created() {
    this.units_catalog = this.getUnits();
    const unit = this.$props.initialUnit;
    if (unit) {
      this.onClickUnit(unit);
    } else {
      this.currentUnit = this.getUnitByCode("539");
    }
    if (this.$props.isShort) {
      this.unitQuery = this.currentUnit.shortName;
    } else {
      this.unitQuery = this.currentUnit.fullName;
    }
  },
  methods: {
    onFocusInUnits() {
      this.unitsFocus = true;
    },
    onFocusOutUnits() {
      this.unitsFocus = false;
    },
    onClickUnit(code) {
      const unit = this.getUnitByCode(code);
      this.currentUnit = unit;
      if (this.$props.isShort) {
        this.unitQuery = unit.shortName;
      } else {
        this.unitQuery = unit.fullName;
      }

      this.$emit('selectUnit',this.currentUnit);
    },
    getUnitListText(item) {
      const result = item.fullName;
      if (item.shortName === undefined) {
        return result;
      }
      return result + " " + "(" + item.shortName + ")"
    },
  },
  computed: {
    filteredUnits() {
      const query = this.unitQuery.toLowerCase();
      return this.units_catalog.filter(function (item) {
        const code = item.code.toLowerCase().includes(query);
        const fullName = item.fullName.toLowerCase().includes(query);
        if (item.shortName !== undefined) {
          const shortName = item.shortName.toLowerCase().includes(query);
          return code || fullName || shortName;
        }

        return code || fullName;
      });
    }
  },
}
</script>

<style>
.unit-autocomplete-input {
  max-height: 250px;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
}

.unit-autocomplete-input .list-group-item {
  padding: 0.5rem 1rem;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/UnitSelect.vue